import { render } from "./VirtualSkipperView.vue?vue&type=template&id=512fcf4e&scoped=true"
import script from "./VirtualSkipperView.vue?vue&type=script&lang=js"
export * from "./VirtualSkipperView.vue?vue&type=script&lang=js"

import "./VirtualSkipperView.vue?vue&type=style&index=0&id=512fcf4e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-512fcf4e"]])

export default __exports__